//Список проектов для указанного пользователя и объекта
export default function ProjectForUserObjectList(listProject, listObject, listUser, idObject, idUser, idRole) {

    if (listProject !== null & listObject != null & listUser != null & idObject != null & idUser != null & idRole != null) {


        //Добавляем где "все объекты" = "Да"
        const projectObject1 = listProject.filter(a => a.All_Object === true & a.ID_Status === 1);
        //Добавляем где "все объекты" = "Нет" и объект указан в настройках проекта
        const projectObject2 = listObject.filter(a => a.ID_Object === idObject).map(item => {
            return listProject.filter(a => a.ID === item.ID_Project)[0]
        })

        const projectObject = [...projectObject1, ...projectObject2]

        //Если админ, то все проекты доступны
        if (idRole === 0 || idRole === 1) {
            return projectObject;
        }
        //Если пользователь
        else {

            //Добавляем где "Все пользователи" = "Да"
            const projectUser1 = projectObject.filter(a => a.All_User === true);
            //Добавляем где "Все пользователи" = "Нет" , но пользователь указан в настройках
            const projectUser2 = listUser.filter(a => a.ID_User === idUser).map(item => {
                return listProject.filter(a => a.ID === item.ID_Project)[0]
            })

            return [...projectUser1, ...projectUser2];
        }
    }
    else {
        return [];
    }
}